import { createFileRoute } from "@tanstack/react-router";

import { enumParam, stringParam } from "../../../lib/url-state";
import {
  RunDetailPage,
  type LogLevel,
  type RunDetailSearch,
  type RunDetailTab,
} from "../../../workspaces/training/pages/RunDetailPage";

const TABS: readonly RunDetailTab[] = ["charts", "performance", "files", "activity", "logs", "config", "results"];
const LEVELS: readonly LogLevel[] = ["all", "debug", "info", "warning", "error"];

export const Route = createFileRoute("/_console/p/$org/$project/training/runs/$runId")({
  validateSearch: (search: Record<string, unknown>): RunDetailSearch => ({
    tab: enumParam(search.tab, TABS),
    log: stringParam(search.log),
    level: enumParam(search.level, LEVELS),
  }),
  component: RunDetailRoute,
});

function RunDetailRoute() {
  const { runId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RunDetailPage
      runId={runId}
      search={search}
      onSearchChange={(patch, options) =>
        void navigate({
          search: (current) => ({ ...current, ...patch }),
          replace: options?.replace,
        })
      }
    />
  );
}
